module.exports = __webpack_public_path__ + "static/img/Clint-Gutherson.cde4b6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Clint-Gutherson.jpg
// module id = 6OQu
// module chunks = 0